import React from "react";

import BoardPresenter from "./BoardPresenter";

export default class extends React.Component {

  render() {
    return <BoardPresenter />;
  }
}
